import { render, staticRenderFns } from "./transferIcon.vue?vue&type=template&id=13ff75ba&"
import script from "./transferIcon.vue?vue&type=script&lang=js&"
export * from "./transferIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports